import { api } from "@/api/client";

/**
 * Phase 4.9 — Schedule API client.
 *
 * All endpoints live under /api/schedules.
 */
const schedules = {
  // Schedules
  list: (active_only = false) =>
    api.get("/schedules/", { params: { active_only } }),
  current: () => api.get("/schedules/current"),
  byId: (id) => api.get(`/schedules/${id}`),
  upload: (file, onProgress) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/schedules/upload", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: onProgress,
    });
  },
  activate: (id) => api.post(`/schedules/${id}/activate`),
  remove: (id) => api.delete(`/schedules/${id}`),

  // Entries
  patchEntry: (schedId, entryId, patch) =>
    api.patch(`/schedules/${schedId}/entries/${entryId}`, patch),
  createEntry: (schedId, payload) =>
    api.post(`/schedules/${schedId}/entries`, payload),
  deleteEntry: (schedId, entryId) =>
    api.delete(`/schedules/${schedId}/entries/${entryId}`),
  moveEmployee: (schedId, nameNorm, section_id) =>
    api.post(`/schedules/${schedId}/employees/${encodeURIComponent(nameNorm)}/move-section`, { section_id }),

  // Sections
  listSections: () => api.get("/schedules/sections"),
  createSection: (body) => api.post("/schedules/sections", body),
  patchSection: (id, body) => api.patch(`/schedules/sections/${id}`, body),
  deleteSection: (id) => api.delete(`/schedules/sections/${id}`),

  // Anomalies
  anomalies: (schedId) => api.get(`/schedules/${schedId}/anomalies`),
};

export default schedules;
